import { SET_CENTER_CURRENT_PAGE, SET_PAGINATED_CENTERS } from '../actionTypes';

export const initialState = {
    currentPage: 1,
    itemsPerPage: 10,
    paginatedCenters: [],
};

/**
 * dispatch centers pagination reducer
 * see https://redux.js.org/
 * @param {object} state
 * @param {object} action
 */

const reducer = (state = initialState, action) => {
    if (action.type === SET_CENTER_CURRENT_PAGE) {
        return {
            ...state,
            currentPage: action.currentPage,
        };
    }
    if (action.type === SET_PAGINATED_CENTERS) {
        return {
            ...state,
            paginatedCenters: action.paginatedCenters,
        };
    }
    return state;
};

export default reducer;
